import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../constants/local-storage-keys';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  constructor() {

  }

  private lset(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  private lget(key: string) {
    return localStorage.getItem(key);
  }

  private lremove(key: string): void {
    localStorage.removeItem(key);
  }

  public getAuthToken() {
    return this.lget(LocalStorageKeys.AUTH_TOKEN);
  }

  public setAuthToken(value: string): void {
    this.lset(LocalStorageKeys.AUTH_TOKEN, value);
  }

  public clearAuthToken(): void {
    this.lremove(LocalStorageKeys.AUTH_TOKEN);
  }
}
